@if (optional && selected) {
<div class="mb-4 pb-2">
  <app-button type="secondary" (clickEvent)="onClearClick()">
    <div class="flex justify-center text-center items-center">{{'shared.date-input.actions.clear' | translate}}</div>
  </app-button>
</div>
}

<ng-template [cdkPortalOutlet]="_calendarHeaderPortal"></ng-template>

<div class="outline-none" cdkMonitorSubtreeFocus tabindex="-1">
  @switch (currentView) { @case ('month') {
  <mat-month-view
    [(activeDate)]="activeDate"
    [selected]="selected"
    [dateFilter]="dateFilter"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [dateClass]="dateClass"
    [comparisonStart]="comparisonStart"
    [comparisonEnd]="comparisonEnd"
    (_userSelection)="_dateSelected($event)"
  >
  </mat-month-view>
  } @case ('year') {
  <mat-year-view
    [(activeDate)]="activeDate"
    [selected]="selected"
    [dateFilter]="dateFilter"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [dateClass]="dateClass"
    (monthSelected)="_monthSelectedInYearView($event)"
    (selectedChange)="onlyView ? _monthSelected($event) : _goToDateInView($event, 'month')"
  >
  </mat-year-view>
  } @case ('multi-year') {
  <mat-multi-year-view
    [(activeDate)]="activeDate"
    [selected]="selected"
    [dateFilter]="dateFilter"
    [maxDate]="maxDate"
    [minDate]="minDate"
    [dateClass]="dateClass"
    (yearSelected)="_yearSelectedInMultiYearView($event)"
    (selectedChange)="onlyView ? _yearSelected($event) : _goToDateInView($event, 'year')"
  >
  </mat-multi-year-view>
  } }
</div>
